import SettingsPatternMyMenu from './SettingsPatternMyMenu';
export default SettingsPatternMyMenu;